import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { LocalStorageService } from 'lib/utils/services/localStorage.service'
import { AUTH_API_URL, isDevelop } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class AuthService {
  static getSubdivisions = async branchCode => {
    if (!branchCode) {
      return null
    }

    try {
      const data = {
        branchCode: typeof branchCode === 'object' ? branchCode.code : branchCode
      }

      const result = await HTTPHandler.post(AUTH_API_URL + '/dictionary/subdivisions', data)

      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static login = async data => {
    if (isDevelop) {
      data.longitude = 777
      data.latitude = 777
    }

    try {
      const result = await HTTPHandler.post(AUTH_API_URL + '/authenticate', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getUserByToken = async () => {
    try {
      const result = await HTTPHandler.get(AUTH_API_URL + '/users/getUserByToken')
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getUsers = async data => {
    try {
      const result = await HTTPHandler.post(AUTH_API_URL + '/users/getUsers', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getBranches = async () => {
    try {
      const result = await HTTPHandler.get(AUTH_API_URL + '/branches')
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static setToken = token => {
    if (!!token) {
      LocalStorageService.setAccessToken(token)
      HTTPHandler.api.defaults.headers.Authorization = `Bearer ${token}`
    } else {
      LocalStorageService.removeAccessToken()
      delete HTTPHandler.api.defaults.headers.Authorization
    }
  }
}
